import React from 'react'
import TailorMadeTemplate from '../../../components/template/TailorMadeTemplate/TailorMadeTemplate'
import { api, getApiClient } from '../../../utils'
import { PAGINEDETAIL } from '../../../utils/endpoint'

const TailorMadePage = ({ page }) => {
  return <TailorMadeTemplate page={page} />
}

TailorMadePage.loginRequired = true

export default TailorMadePage

export async function getServerSideProps({ params, locale, req }) {
  const api = getApiClient(req)
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: { chiave: 'tailor-made', lang: locale },
  })
  const page = await pageResponse.data

  const toolbarProps = { toolbarPage: page }
  return {
    props: { page, ...toolbarProps },
  }
}
